export default "__VITE_ASSET__iUF1LKdj__"